import { PayloadAction } from "@reduxjs/toolkit";
import { LocationsState } from "../../models/LocationsState";
import { CreateLocationPayload } from "../../payload/CreateLocation/CreateLocationPayload";

const createLocationFetch = (state: LocationsState, action: PayloadAction<CreateLocationPayload>) => {
    state.isLoading = true;
}

export default createLocationFetch;